import { css } from '@emotion/core';
import { API } from "aws-amplify";
import axios from 'axios';
import 'containers/common/Detail.css';
import Moment from "moment";
import React, { Component } from "react";
import { Accordion, Button, Card, Col, Form, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
// First way to import
import { PacmanLoader } from 'react-spinners';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import DatePicker from "react-datepicker";






const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class ProofingHome extends Component {
    constructor(props) {
        super(props);


        this.state = {
            isLoading: null,
            isDeleting: null,
            cityscopeOptions: [],
            selectedCityscope: null,
            cityscope: null,

            scopeChecks: null,
            ledChecks: null
        };



       

    }

    


  
    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   

            const cityscopeOptions = await this.getCityscopes();
            if (cityscopeOptions) {     
                this.setState(state => ({ cityscopeOptions }));
            }
            
            
            document.title = "Cityscope Proofing" ;


            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount() {
        source.cancel();
    }

    async getCityscopes() {
        return API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token });                
    }

    async getScopeChecks(filter) {
        return API.get("colin", `/proofing/scopechecks`, { 'queryStringParameters': filter,'cancelToken': source.token });                
    }
    async getLedChecks(filter) {
        return API.get("colin", `/proofing/ledchecks`, { 'queryStringParameters': filter,'cancelToken': source.token });                
    }

    handleCityscopeChange = async (selectedCityscope) => {
        this.setState(state => ({ selectedCityscope }));
        this.setState(state => ({ cityscope: (selectedCityscope) ? selectedCityscope.map(c => c.value).join(',') : null }));
    }

    handleScopeChecks= async (e)=>{
        if (this.state.selectedCityscope && this.state.selectedCityscope.length > 10) {
            alert('Please limit the number of cityscopes to 10.');
            return;
        }

        this.setState({ isLoading: true, ledChecks: null });   
        const scopeChecks = await this.getScopeChecks({scope: this.state.cityscope});
        if (scopeChecks) {     
            this.setState(state => ({ scopeChecks }));
        }

        
        this.setState({ isLoading: false });
    }

    handleLedChecks= async (e)=>{
        if (this.state.selectedCityscope && this.state.selectedCityscope.length > 10) {
            alert('Please limit the number of cityscopes to 10.');
            return;
        }

        this.setState({ isLoading: true, scopeChecks: null });   
        const ledChecks = await this.getLedChecks({scope: this.state.cityscope});
        if (ledChecks) {     
            this.setState(state => ({ ledChecks }));
        }

        
        this.setState({ isLoading: false });
    }

   
    titleCase(str){
        if(str!=null){
            str = str.toLowerCase().split('_');
            let final = [];
            for(let  word of str){
            final.push(word.charAt(0).toUpperCase()+ word.slice(1));
            }
            return final.join(' ')   
        }
        else{
            return str
        }  
     }

     renderCell = cell =>{
        if(cell.column.id.toLowerCase().indexOf("date")>=0 && cell.value !== null ){
             return  Moment(new Date(cell.value))
             .local()
             .format("DD-MM-YYYY")
        }
        else if((cell.value === true || cell.value === false))
        {
            return (
                <Form.Check checked={cell.value}                    
                    label=""
                    disabled
                    type="checkbox"           
                    style={{
                        textAlign: "center"
                    }}
                />);
        }
        else{
            return cell.value
        }
     }

     handleCheckboxChange = (cellInfo, checkid, event) => {
         console.log(cellInfo);
         console.log(checkid);
         if(this.state.scopeChecks){
            let scopeChecks = [...this.state.scopeChecks];

            const indexOfCheck= scopeChecks.map(check=> check.proofing.id).indexOf(checkid);
            
            scopeChecks[indexOfCheck]['proofing']['res'][cellInfo.index]['selected'] = event.target.checked;

            this.setState(scopeChecks);
         }
         if(this.state.ledChecks){
            let ledChecks = [...this.state.ledChecks];

            const indexOfCheck= ledChecks.map(check=> check.proofing.id).indexOf(checkid);
            
            ledChecks[indexOfCheck]['proofing']['res'][cellInfo.index]['selected'] = event.target.checked;

            this.setState(ledChecks);
         }
         
        // let data = [...this.props.data];
        // data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        // data[cellInfo.index].modified = true;
        // this.props.updateTableState(data, this.state.dataSet);
    };
    
     renderEditable = (cell,checkid) => {
        return (
            <Form.Check checked={cell.value}                    
                label=""
                onChange={this.handleCheckboxChange.bind(null, cell, checkid)}
                type="checkbox"           
                style={{
                    textAlign: "center"
                }}
            />);    }

    render() {
        return (
            <div className="Proofing">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
               
                {this.state.cityscopeOptions && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="ProofingForm">
                    <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Proofing
                                </h6>
                    
                        </Col>
                    </Row>
                    <Form  >
                                            
                        <Row className="justify-content-md-center">
                            <Col sm={2} md={2} lg={2}>
                                <Form.Group controlId="cityscope" >
                                    
                                    
                                        <Select
                                            value={this.state.selectedCityscope}
                                            onChange={this.handleCityscopeChange}
                                            options={this.state.cityscopeOptions}
                                            placeholder="Cityscope"
                                            isMulti
                                        />
                                   

                                </Form.Group>
                            </Col>
                        
                            <Col sm={2} md={2} lg={2}>
                                <Button variant="primary" block onClick={this.handleScopeChecks}>Property Checks</Button><br />
                            </Col>
                        
                            <Col sm={2} md={2} lg={2}>
                                <Button variant="primary" block  onClick={this.handleLedChecks}>Tenant/Lease Checks</Button><br />
                            </Col>
                        
                            {/* <Col sm={2} md={2} lg={2}>
                                <Button variant="primary" block>Reference Checks</Button><br />
                        </Col>                       
                        
                            <Col sm={2} md={2} lg={2}>
                                <Button variant="primary" block>Sales Checks</Button><br />
                            </Col>
                        
                            <Col sm={2} md={2} lg={2}>
                                <Button variant="primary" block>Suburb Checks</Button><br />
                            </Col> */}
                        </Row>
                        
                    </Form>



                    <div className="proofResults">
                    
                    { this.state.scopeChecks &&
                    <div>
                        <Accordion defaultActiveKey="0">
                      {this.state.scopeChecks.map(check => (
                        <Card key={check.id}>
                            <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey={check.proofing.id}>
                            <Card.Title>{check.proofing.query_name}:  Fail results: {check.proofing.res ? <font color="red">{check.proofing.res.length}</font>: 0}</Card.Title>
                            </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={check.proofing.id}>
                            <Card.Body>
                                <p>{check.proofing.query_desc}</p>
                            {check.proofing.res && 
                            <ReactTable
                                data={check.proofing.res}
                                columns={Object.keys(check.proofing.res[0]).map((e, i) => {
                                                                            if (e==="property_key"){
                                                                                        return {
                                                                                                    id: e,
                                                                                                    Header: "Cityscope Ref",
                                                                                                    accessor: e, 
                                                                                                    
                                                                                                    Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./properties/${r.value}?browselist=`+check.proofing.res.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.property_key).join(",")} target="new">{r.value}</a> ,
               
                                                                                                    style: { 'white-space': 'unset' } ,
                                                                                                    maxWidth: 100
                                                                                                }
                                                                                            }
                                                                            else if (e==="entity_id"){
                                                                                return {
                                                                                            id: e,
                                                                                            Header: this.titleCase(e),
                                                                                            accessor: e, 
                                                                                            Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./entities/${r.value}`} target="new">{r.value}</a> ,
                                                                                            style: { 'white-space': 'unset' } ,
                                                                                            maxWidth: 100
                                                                                        }
                                                                                    }
                                                                            else if (e==="owner_id"){
                                                                                return {
                                                                                            id: e,
                                                                                            Header: e,
                                                                                            accessor: e, 
                                                                                            Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./owners/${r.value}`} target="new">{r.value}</a> ,
                                                                                            style: { 'white-space': 'unset' } ,
                                                                                            maxWidth: 100
                                                                                        }
                                                                                    }
                                                                            else if (e==="sale_id"){
                                                                                return {
                                                                                            id: e,
                                                                                            Header: e,
                                                                                            accessor: e, 
                                                                                            Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./sales/${r.value}`} target="new">{r.value}</a> ,
                                                                                            style: { 'white-space': 'unset' } ,
                                                                                            maxWidth: 100
                                                                                        }
                                                                                    }
                                                                            else if (e==="selected"){
                                                                                return {
                                                                                    id: e,
                                                                                    Header: '',
                                                                                    maxWidth: 60,
                                                                                    accessor: e,
                                                                                    Cell: row=> this.renderEditable(row,check.proofing.id),
                                                                                    style: { textAlign: "center" }
                                                                                        }
                                                                                    }
                                                                            else{
                                                                                return {
                                                                                    id: e,
                                                                                    Header: this.titleCase(e),
                                                                                    accessor: e,
                                                                                    Cell: this.renderCell,
                                                                                    style: { 'whiteSpace': 'unset' } 
                                                                                    
                                                                                }
                                                                            }

                                            })}
                                defaultPageSize={10}
                                sortable={true}
                            />
                            }
                            
                            
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                      )) } 
                      </Accordion>
                      </div>
                    }

                    { this.state.ledChecks &&
                    <div>
                        <Accordion defaultActiveKey="0">
                      {this.state.ledChecks.map(check => (
                        <Card>
                            <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey={check.proofing.id}>
                            <Card.Title>{check.proofing.query_name}:  Fail results: {check.proofing.res ? <font color="red">{check.proofing.res.length}</font>: 0}</Card.Title>
                            </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={check.proofing.id}>
                            <Card.Body>
                            <p>{check.proofing.query_desc}</p>
                            {check.proofing.res && 
                            <ReactTable
                                data={check.proofing.res}
                                columns={Object.keys(check.proofing.res[0]).map((e, i) => {
                                                                            if (e==="property_key"){
                                                                                        return {
                                                                                                    id: e,
                                                                                                    Header: "Cityscope Ref",
                                                                                                    accessor: e, 
                                                                                                    Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./properties/${r.value}`} target="new">{r.value}</a> ,
                                                                                                    style: { 'white-space': 'unset' } ,
                                                                                                    maxWidth: 100
                                                                                                }
                                                                                            }
                                                                            else if (e==="entity_id"){
                                                                                return {
                                                                                            id: e,
                                                                                            Header: this.titleCase(e),
                                                                                            accessor: e, 
                                                                                            Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./entities/${r.value}`} target="new">{r.value}</a> ,
                                                                                            style: { 'white-space': 'unset' } ,
                                                                                            maxWidth: 100
                                                                                        }
                                                                                    }
                                                                                    else if (e==="owner_id"){
                                                                                        return {
                                                                                                    id: e,
                                                                                                    Header: this.titleCase(e),
                                                                                                    accessor: e, 
                                                                                                    Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./owners/${r.value}`} target="new">{r.value}</a> ,
                                                                                                    style: { 'white-space': 'unset' } ,
                                                                                                    maxWidth: 100
                                                                                                }
                                                                                            }
                                                                                            else if (e==="sale_id"){
                                                                                                return {
                                                                                                            id: e,
                                                                                                            Header: this.titleCase(e),
                                                                                                            accessor: e, 
                                                                                                            Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./sales/${r.value}`} target="new">{r.value}</a> ,
                                                                                                            style: { 'white-space': 'unset' } ,
                                                                                                            maxWidth: 100
                                                                                                        }
                                                                                                    }
                                                                                            else if (e==="lease_id"){
                                                                                                return {
                                                                                                            id: e,
                                                                                                            Header: this.titleCase(e),
                                                                                                            accessor: e, 
                                                                                                            Cell: r => <a target="_blank" rel="noopener noreferrer" href={`./properties/${r.original.property_key}/leases/${r.value}?browselist=`+check.proofing.res.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.lease_id).join(",")} target="new">{r.value}</a> ,
                                                                                                            
                                                                                                            style: { 'white-space': 'unset' } ,
                                                                                                            maxWidth: 100
                                                                                                        }
                                                                                                    }
                                                                                            else if (e==="selected"){
                                                                                                return {
                                                                                                    id: e,
                                                                                                    Header: '',
                                                                                                    maxWidth: 60,
                                                                                                    accessor: e,
                                                                                                    Cell: row=> this.renderEditable(row,check.proofing.id),
                                                                                                    style: { textAlign: "center" }
                                                                                                        }
                                                                                                    }
                                                                         else if (e!=="raw_yield"){
                                                                                return {
                                                                                    id: e,
                                                                                    Header: this.titleCase(e),
                                                                                    accessor: e,
                                                                                    Cell: this.renderCell,
                                                                                    style: { 'white-space': 'unset' } 
                                                                                }
                                                                            }

                                            })}
                                defaultPageSize={10}
                                sortable={true}
                            />
                            }
                            
                            
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                      )) } 
                      </Accordion>
                      </div>
                    }
                    </div>
                    </div>


                }
            </div>
        );
        
    }
}